import { render, staticRenderFns } from "./ChartColoredPeriod.vue?vue&type=template&id=765af208&scoped=true"
import script from "./ChartColoredPeriod.vue?vue&type=script&lang=ts"
export * from "./ChartColoredPeriod.vue?vue&type=script&lang=ts"
import style0 from "./ChartColoredPeriod.vue?vue&type=style&index=0&id=765af208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765af208",
  null
  
)

export default component.exports